import httpAuth from "../../services/httpAuth";
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import {
  getPromotionsError,
  getPromotionsSuccess,
  getSocialsSuccess,
  getWhatAppLinkSuccess,
} from "./promotions.slice";
import { BASE_DEV_URL, getHostnameFromURL } from "../../config/api.config";
import httpNotAuth from "../../services/httpNotAuth";

export const requestPromotions = () => async (dispatch) => {
  try {
    const response = await httpAuth.get("content/sliders");
    // const response = await axios.get(`https://lotus.com/banners`)
    if (response.data.status) {
      dispatch(getPromotionsSuccess(response.data.data));
    }
    return response;
  } catch (e) {
    dispatch(getPromotionsError());
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
};

export const requestSocials = () => async (dispatch) => {
  let data = { slug: `${getHostnameFromURL(BASE_DEV_URL)}-social` };
  try {
    const response = await httpAuth.post(
      "/content/getSocialMediaContent",
      data
    );
    // const response = await axios.get(`https://lotus.com/banners`)
    if (response.data.status) {
      // console.log("response.data.result", response.data.result)
      dispatch(getSocialsSuccess(JSON.parse(response.data.data.description)));
    }
    return response;
  } catch (e) {
    // dispatch(getPromotionsError())
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
};

export const requestNoAuthSocials = () => async (dispatch) => {
  let data = { slug: `${getHostnameFromURL(BASE_DEV_URL)}-social` };
  try {
    const response = await httpNotAuth.post("/content/get", data);
    // const response = await axios.get(`https://lotus.com/banners`)
    if (response.data.status) {
      // console.log("response.data.result", response.data.result)
      dispatch(getSocialsSuccess(JSON.parse(response.data.data.description)));
    }
    return response;
  } catch (e) {
    // dispatch(getPromotionsError())
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
};
export const getEnabledWhatAppLink = () => async (dispatch) => {
  try {
    const response = await httpNotAuth.get(
      "/website/getWhatsAppMagicLinkStatus"
    );


    if (response.data.status) {
      dispatch(
        getWhatAppLinkSuccess(
          JSON.parse(response?.data?.data?.whatsapp_magic_link)
        )
      );
    }
    return response;
  } catch (e) {
    // dispatch(getPromotionsError())
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
};
